import axios from "axios"

axios.defaults.baseURL = 'https://dham.app/backend/api/v1'
// axios.defaults.baseURL = 'http://147.93.28.220:4000/backend/api/v1'
axios.defaults.withCredentials = true;
// axios.defaults.headers =  {
//     'Access-Control-Allow-Origin': '*',
// }
 
/*******************  GUIDS ******************** */
export const getGuides = async ( params ) => {
    const response = await axios.get('/guids', { params })
    return response.data?.data
}

export const getGuideById = async ( id ) => {
    const response = await axios.get(`/get-guide-by-id/${ id }`)
    return response.data?.guide
}


export const guideBooking = async ( formdata ) => {
    const response = await axios.post('/book-guide', formdata)
    return response.data
}
/*********************************************** */



/********************** AUTHENTICATION ***************************** */
export const loginCustomer = async ( body ) => {
    const response = await axios.post('/login-signup', body)
    return response.data?.data
}

export const verifyCustomerOTP = async ( body ) => {
    const response = await axios.post('/otp-verify', body)
    return response.data?.customer
}
/****************************************************************** */


/***************************** BLOGS *************************** */
export const getAllBlogs = async ( params ) => {
    const response = await axios.get('/get-blogs', { params })
    return response.data?.blogs
}

export const getBlogById =  async ( id ) => {
    const response = await axios.get(`/get-blog-by-id/${ id }`)
    return response.data?.data
}

export const recentBlogs = async () => {
    const response = await axios.get('/recent-blogs')
    return response.data?.updatedBlogs
}
/**************************************************************** */

/************************* Locations ************************** */
export const getAllCities = async () => {
    const response = await axios.get('/get-all-city')
    return response.data?.cities
}

export const upcomingToursAndEvents = async ( ) => {
    const response = await axios.get('/upcoming-tours-events')
    return response.data?.upcommingToursAndEvent
}

export const getToursAndEvents = async ( search ) => {
    const response = await axios.get('/all-events-tours', { params: { search }})
    return response.data
}

export const  getTourEventDetails = async ( id ) => {
    const response = await axios.get(`/event-tour-by-id/${ id }`)
    return response.data.tourAndEvent
}
/**************************************************************** */


/************************ Hotels ********************** */

export const getHotelByCity = async ( city ) => {    
    const response = await axios.get('/get-hotel-by-city', { params: city })
    return response.data
}

export const getTopHotel = async ( city ) => {
    const response = await axios.get('/top-hotels', { params: { city }})
    return response.data?.data
}

export const getHotelDetails = async ( id ) => {
    const response = await axios.get(`/get-hotel-by-id/${id}`)
    return response.data?.data
}

export const addToWhishlist = async ( id ) => {
    const response = await axios.post('/add-to-wishlist', { hotelId: id })
    return response.data
}

export const bookProperty = async ( data ) => {
    const response = await axios.post('/book-property', data )
    return response.data
} 

export const getRoomsByHotel = async ( hotelId ) => {
    const response = await axios.get(`/get-room-by-hotel/${ hotelId }`)
    return response.data.data
}
/**************************************************** */

/********************** Filters ******************* */
export const allPropertTypes = async () => {
    const response = await axios.get('/get-all-property-type')
    return response.data?.propertyType
}

export const allAmenities = async () => {
    const response = await axios.get('/get-amenities')
    return response.data?.data
}
/************************************************** */


/******************** Epuja *********************** */
export const getEpujaList = async ( params ) => {
    const response = await axios.get('/ePuja', { params })
    return response.data
}

export const getEPujaDetails = async ( id ) => {
    const response = await axios.get(`/ePuja-by-id/${ id }`)
    return response.data.data
}

export const bookEpuja = async ( data ) => {
    const response = await axios.post('/book-puja', data )
    return response.data
}
/************************************************** */

/***********************Homepage **************** */
export const homeSearch = async (params) => {
    const response = await axios.get('/search', { params })
    return response.data
}
/************************************************** */


/****************** CUSTOMER ********************** */
export const getCustomerBookings = async () => {
    const response = await axios.get("/get-my-booking")
    return response.data.bookings
}
/************************************************** */

/******************** PAGES ********************* */
export const getPageContent = async ({ title }) => {
    const response = await axios.get('/page', { params: { title }})
    return response.data.data
}
/************************************************** */